<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import AwardManagement from '@/model/dataLayer/api/MembershipSystem/AwardManagement'
import AwardDetailDialog from './AwardDetailDialog.vue'
import { createAwardFormSchema } from '@/model/baseForm/awardFormSchemas'

export default {
  name: 'AwardManagement',
  components: {
    IkDataTable,
    AwardDetailDialog
  },
  data () {
    return {
      model: AwardManagement,
      showDetailDialog: false,
      selectedAwardId: null
    }
  },
  computed: {
    awardFormSchema () {
      return createAwardFormSchema()
    }
  },
  async mounted () {
    await this.reload()
  },
  methods: {
    async reload () {
      if (this.$refs.table) {
        await this.$refs.table.reload()
      }
    },
    handleRowClick (item) {
      this.selectedAwardId = String(item.id)
      this.showDetailDialog = true
    },
    handleAction (action, item) {
      if (action === 'detail' || action === 'edit') {
        this.selectedAwardId = String(item.id)
        this.showDetailDialog = true
      }
    },
    handleEdit (award) {
      // Reload the table to reflect the changes
      this.reload()
    }
  }
}
</script>

<template>
  <v-container>
    <ik-data-table
      ref="table"
      :model="model"
      entity-name="奖励管理"
      icon="mdi-cash-usd"
      :custom-on-row-click="handleRowClick"
      :use-edit-action="false"
      :form-schema="awardFormSchema"
      @action="handleAction"
    >
      <template #item.action="{item}">
        <v-list-item
          @click="handleRowClick(item)"
        >
          <v-list-item-title>
            {{ $t('edit') }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </ik-data-table>

    <award-detail-dialog
      v-model="showDetailDialog"
      :award-id="selectedAwardId"
      @edit="handleEdit"
    />
  </v-container>
</template>

<style scoped>

</style>
